export const SET_RESIDENCE = (state, value) => {
  state.residence = value
}

export const SET_CORPORATE_NAME = (state, value) => {
  state.corporateName = value
}

export const SET_TRADENAME = (state, value) => {
  state.tradeName = value
}

export const SET_DOCUMENT = (state, value) => {
  state.document = value
}

export const SET_ADDRESS_STREET = (state, value) => {
  state.address.street = value
}

export const SET_ADDRESS_POSTALCODE = (state, value) => {
  state.address.postalCode = value
}

export const SET_ADDRESS_TOWN = (state, value) => {
  state.address.town = value
}

export const SET_ADDRESS_CITY = (state, value) => {
  state.address.city = value
}

export const SET_ADDRESS_COUNTRY = (state, value) => {
  state.address.country = value
}

export const SET_REGISTRATION_BOOK = (state, value) => {
  state.registrationData.book = value
}

export const SET_REGISTRATION_FOLIO = (state, value) => {
  state.registrationData.folio = value
}

export const SET_REGISTRATION_SHEET = (state, value) => {
  state.registrationData.sheet = value
}

export const SET_REGISTRATION_SECTION = (state, value) => {
  state.registrationData.section = value
}

export const SET_REGISTRATION_VOLUME = (state, value) => {
  state.registrationData.volume = value
}

export const SET_REGISTRATION_MERCANTILE_REGISTRY = (state, value) => {
  state.registrationData.mercantileRegistry = value
}

export const SET_REGISTRATION_ADDITIONAL_INFO = (state, value) => {
  state.registrationData.additionalRegistrationData = value
}

export const SET_MEDIUM_MAIL = (state, value) => {
  state.medium.email = value
}

export const SET_MEDIUM_FAX = (state, value) => {
  state.medium.fax = value
}

export const SET_MEDIUM_PHONE = (state, value) => {
  state.medium.phone = value
}

export const SET_MEDIUM_WEB = (state, value) => {
  state.medium.web = value
}

export const SET_MEDIUM_CONTACT_PERSON = (state, value) => {
  state.medium.name = value
}

export const SET_MEDIUM_ADDITIONAL_INFO = (state, value) => {
  state.medium.additionalContactDetails = value
}
